import React from 'react'

import T from 'components/FormattedMessage'
import Button from 'components/Button'
import AutoSub from 'components/AutoSub'

import { withAutoSub, InjectedAutoSubProps } from 'contexts/AutoSub'
import config from 'config'

interface Props {
}

type InjectedProps = Props & InjectedAutoSubProps

const ProfileAutoSub: React.SFC<InjectedProps> = props => {
  if (props.remainingSubs < 1 && config.IS_STORE_DISABLED) {
    return null
  }

  return (
    <AutoSub
      {...props}
      rightChild={!config.IS_STORE_DISABLED && (
        <Button
          fullWidth
          size="small"
          variant="contained"
          color="secondary"
          onClick={props.onStoreClick}
        >
          <T id="autosub_action_buy" />
        </Button>
      )}
      message={(
        props.remainingSubs < 1
          ? <T id="autosub_message_notickets" />
          : <T id="autosub_message_available" />
      )}
    />
  )
}

export default withAutoSub(ProfileAutoSub)
